import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createInventoryConvert, editInventoryConvert, fetchInventoryConvertDetail } from '../../actions/inventoryConverts_actions';
import { fetchInventories } from '../../actions/inventoryConverts_actions';

import InventoryConvertForm from '../../components/Inventories/inventoryConvertForm';

const validate = values => {
  const errors = {}
  if (!values.Quantity) {
      errors.Quantity = 'Required'
  }
  if (!values.ConvertedQuantity) {
      errors.ConvertedQuantity = 'Required'
  }
  if (!values.ToZone) {
      errors.ToZone = 'Required'
  }
  if (!values.ToBin) {
      errors.ToBin = 'Required'
  }
  return errors
}

let inventoryConvertForm = reduxForm({
    form: 'inventoryConvertForm',
    validate
})(InventoryConvertForm);

const selector = formValueSelector('inventoryConvertForm')

function mapStateToProps(state) {
    const toZoneValue = selector(state, 'ToZone');
    const toBinValue = selector(state, 'ToBin');
    const quantityValue = selector(state, 'Quantity');
    const convertedQuantityValue = selector(state, 'ConvertedQuantity');
    const postingDate = selector(state, 'PostingDate');
    const note = selector(state, 'Note');
    const processingFee = selector(state, 'ProcessingFee');
    return {
        quantityValue,
        convertedQuantityValue,
        toZoneValue,
        toBinValue,
        postingDate,
        note,
        processingFee,

        currentInventoryConvert: state.inventoryConverts.currentInventoryConvert,
        currentInventoryConvertDetail: state.inventoryConverts.currentInventoryConvertDetail,
        detailIsLoading: state.inventoryConverts.detailIsLoading,
        detailError: state.inventoryConverts.detailError,
        initialValues: state.inventoryConverts.currentInventoryConvertDetail,
        isCreating: state.inventoryConverts.isCreating,
        createError: state.inventoryConverts.createError,
        created: state.inventoryConverts.created,
        isEditing: state.inventoryConverts.isEditing,
        editError: state.inventoryConverts.editError,
        edited: state.inventoryConverts.edited,
        inventories: state.inventoryConverts.inventories,

        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { createInventoryConvert, editInventoryConvert, fetchInventoryConvertDetail, fetchInventories })(inventoryConvertForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryConvertForm.jsx